import { createAction } from '@reduxjs/toolkit';
import {
  SignalingContentWhiteboardUpdatePayload,
  SignalingContentWhiteboardPayload,
  SignalingLaserUpdatedPayload,
  SignalingScreenshareWhiteboardPayload,
  SignalingScreenshareWhiteboardUpdatePayload,
  SignalingScreenshareLaserUpdatedPayload,
} from 'features/content-whiteboard/types';
import type { UserId } from 'features/users/types';
import type { FeedId } from 'features/streaming/types';

export const signalingContentWhiteboardUpdated =
  createAction<SignalingContentWhiteboardUpdatePayload>('signaling/contentWhiteboardUpdated');

export const signalingContentWhiteboardDataReceived =
  createAction<SignalingContentWhiteboardPayload>('signaling/contentWhiteboardDataReceived');

export const signalingContentWhiteboardLaserUpdated = createAction<SignalingLaserUpdatedPayload>(
  'signaling/contentWhiteboardLaserUpdated'
);

export const requestContentWhiteboardData = createAction<{ id: string; page: number }>(
  'requestContentWhiteboardData'
);

export const signalingScreenshareWhiteboardUpdated =
  createAction<SignalingScreenshareWhiteboardUpdatePayload>(
    'signaling/screenshareWhiteboardUpdated'
  );

export const signalingScreenshareWhiteboardDataReceived =
  createAction<SignalingScreenshareWhiteboardPayload>(
    'signaling/screenshareWhiteboardDataReceived'
  );

export const signalingScreenshareWhiteboardLaserUpdated =
  createAction<SignalingScreenshareLaserUpdatedPayload>(
    'signaling/screenshareWhiteboardLaserUpdated'
  );

export const requestScreenshareWhiteboardData = createAction<{ feedId: FeedId; userId: UserId }>(
  'requestScreenshareWhiteboardData'
);
